export {
  default as heated,
  ReactComponent as Heated,
} from '@assets/icons/categories/heated.svg'    
